define('view/people/profile.detail.view',['require','exports','module','uikit/uikit','fukit/fukit','backbone.radio','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var UIKit       = require('uikit/uikit'),
      RolesHelper = require('fukit/fukit').RolesHelper,
      Radio       = require('backbone.radio'),
      ROLES       = require('fukit/fukit').Roles;

  //behaviors
  // var EnableOnlyOnUnsavedChangesBehavior            = require('behavior/enable.only.on.unsaved.changes.behavior');
  // var EnableLoadingOnModelRequestBehavior           = require('behavior/enable.loading.on.model.request.behavior');
  // var ShowModalOnNavigateWithUnsavedChangesBehavior = require('behavior/show.modal.on.navigate.with.unsaved.changes.behavior');
  // var AuthorizationBehavior                         = require('behavior/authorization.behavior');

  // var ANY_INTERNAL_AFFILIATION_ROLE = [ROLES.PERSON_INTERNAL_AFFILIATION_CREATE, ROLES.PERSON_INTERNAL_AFFILIATION_READ, ROLES.PERSON_INTERNAL_AFFILIATION_UPDATE, ROLES.PERSON_INTERNAL_AFFILIATION_DELETE];
  // var CREATE_UPDATE_OPTIONS = [
  //   {
  //     filter: function() {
  //       var state = Radio.request('AppKit.controllerService', 'state');
  //
  //       return state.get('authorizationMode') === 'create';
  //     },
  //     message:  function() {
  //       var readOnly = RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ']) && RolesHelper.evaluateRoleArrayAgainstUserRoles(ANY_INTERNAL_AFFILIATION_ROLE);
  //
  //       return 'You do not have permission to edit this' + ((readOnly) ? ' page.' : '.');
  //     },
  //     roles: [
  //       ANY_INTERNAL_AFFILIATION_ROLE,
  //       [ROLES.PERSON_PROFILE_CREATE]
  //     ]
  //   },
  //   {
  //     filter: function() {
  //       return true
  //     },
  //     message: function() {
  //       var readOnly = RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ']) && RolesHelper.evaluateRoleArrayAgainstUserRoles(ANY_INTERNAL_AFFILIATION_ROLE);
  //
  //       return 'You do not have permission to edit this' + ((readOnly) ? ' page.' : '.');
  //     },
  //     roles: [
  //       ANY_INTERNAL_AFFILIATION_ROLE,
  //       [ROLES.PERSON_PROFILE_UPDATE]
  //     ]
  //   }
  // ];

  var ProfileDetailsView = UIKit.ItemView.extend({
    template: 'people.profile.detail',

    internalViewOptions: {
      profileFormView: {
        type: UIKit.Form,
        showValidationMessage: false,
        showFieldValidationMessage: true,
      },
      firstName: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'firstName',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: CREATE_UPDATE_OPTIONS,
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      lastName: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'lastName',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: CREATE_UPDATE_OPTIONS,
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      prefix: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'prefix',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: CREATE_UPDATE_OPTIONS,
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      middleName: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'middleName',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: CREATE_UPDATE_OPTIONS,
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      suffix: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'suffix',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: CREATE_UPDATE_OPTIONS,
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
    },

    onInjectedProfileFormView: function() {
      var firstNameInput = this.buildComponent({ name: 'firstName' });
      var lastNameInput = this.buildComponent({ name: 'lastName' });
      var prefixInput = this.buildComponent({ name: 'prefix' });
      var middleNameInput = this.buildComponent({ name: 'middleName' });
      var suffixInput = this.buildComponent({ name: 'suffix' });

      this.bindOption('model', 'model', this.profileFormView);
      this.profileFormView
        .addGroup()
        .addField({ text: 'First Name', size: 8, required: true }, firstNameInput)
        .parent()
        .addField({ text: 'Last Name', size: 8, required: true }, lastNameInput)
        .parent()
        .parent()
        .addGroup()
        .addField({ text: 'Prefix' }, prefixInput)
        .parent()
        .addField({ text: 'Middle Name' }, middleNameInput)
        .parent()
        .addField({ text: 'Suffix' }, suffixInput)
        .parent()
        .parent();
    },
  });
  module.exports = ProfileDetailsView;
});

